import { IconProps } from "../../../types/style";

const ArrowStepLeft = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height="13"
        viewBox="0 0 25 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.469669 5.96967C0.176777 6.26256 0.176777 6.73743 0.469669 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96446 6.59619 1.48959 6.3033 1.1967C6.01041 0.903804 5.53553 0.903804 5.24264 1.1967L0.469669 5.96967ZM25 5.75L23.5 5.75L23.5 7.25L25 7.25L25 5.75ZM20.5 5.75L17.5 5.75L17.5 7.25L20.5 7.25L20.5 5.75ZM14.5 5.75L11.5 5.75L11.5 7.25L14.5 7.25L14.5 5.75ZM8.5 5.75L5.5 5.75L5.5 7.25L8.5 7.25L8.5 5.75ZM2.5 5.75L1 5.75L1 7.25L2.5 7.25L2.5 5.75ZM0.469669 5.96967C0.176777 6.26256 0.176777 6.73743 0.469669 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96446 6.59619 1.48959 6.3033 1.1967C6.01041 0.903804 5.53553 0.903804 5.24264 1.1967L0.469669 5.96967ZM25 5.75L23.5 5.75L23.5 7.25L25 7.25L25 5.75ZM20.5 5.75L17.5 5.75L17.5 7.25L20.5 7.25L20.5 5.75ZM14.5 5.75L11.5 5.75L11.5 7.25L14.5 7.25L14.5 5.75ZM8.5 5.75L5.5 5.75L5.5 7.25L8.5 7.25L8.5 5.75ZM2.5 5.75L1 5.75L1 7.25L2.5 7.25L2.5 5.75Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default ArrowStepLeft;
